import { Handle, Position } from 'reactflow';
import { memo, useContext } from 'react';
import { WorkflowContext } from 'providers/workflow-provider';
import { conditionWorkflow } from 'config';
import { HelpIcon } from 'components/generic';
import Images from 'assets/Images';
import './style.scss';

const HeaderNode = ({ id, data }) => {
	const context = useContext(WorkflowContext);
	const { addNode, handleComponentClick, dockerState, nodes } = context;

	const handleAdd = () => {
		dockerState !== 'view' && addNode({ id, data });
	};

	const handleConditionClick = e => {
		handleComponentClick(e);
	};

	return (
		<div className='header-node'>
			<h6 className='header-node__header'>{data?.title}</h6>
			<div className='header-node__description'>
				{data?.description}
				<ul className='header-node__conditions space-between'>
					{conditionWorkflow?.map((el, i) => (
						<li key={i} onClick={() => handleConditionClick(el?.key)} className='space-around'>
							<div className='header-node__conditionItem flex-start'>
								{el?.value}
								<HelpIcon infoContent={el?.infoContent} />
							</div>
						</li>
					))}
				</ul>
			</div>
			<Handle type='source' position={Position.Bottom} id={`bottom-${id}`} />
			{nodes?.length === 1 && <img className='header-node__add' src={Images?.add} alt='Add' onClick={handleAdd} />}
		</div>
	);
};

export default memo(HeaderNode);
